import { Link, useUserMenu } from "react-admin"
import { MenuItem, ListItemIcon, ListItemText } from "@mui/material"

interface IProps {
  title: string
  link: string
  icon?: JSX.Element
}

const GenericMenuItem = ({title, link, icon}: IProps) => {

  const { onClose } = useUserMenu()

  return (
    <MenuItem
      component={Link}
      to={link}
      onClick={onClose}
    >
      <ListItemIcon>
        {icon}
      </ListItemIcon>      
      <ListItemText>
        {title}
      </ListItemText>
    </MenuItem>
  )
}

export default GenericMenuItem